import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import Grid from "@mui/material/Grid2";
import RefreshIcon from "@mui/icons-material/Refresh";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import {
  DeleteReturnsManagement,
  ReturnsListQuery,
  statusChangeMutation,
} from "./graphQl";
import { MdChangeCircle } from "react-icons/md";
import { DeliveryDining } from "@mui/icons-material";
import AssignDeliveryForm from "./assignDeliveryForm";
import RoleAccess from "../../function/RoleAccess";
import PickedStatusChip from "./statusCard/PickedStatus";

const ReturnsManagement = () => {
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [toDate, setToDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [returnsData, setReturnsData] = useState([]);
  const [formState, setFormState] = useState(null);

  //UseEffect to run API Function when tabValue is changed
  useEffect(() => {
    fetchReturnsData();
  }, [tabValue, toDate, fromDate]);

  //Data Fetching Function for List
  const fetchReturnsData = async () => {
    try {
      setIsLoading(true);
      const response = await request(BASEURL, ReturnsListQuery, {
        filter: {
          fromDate: fromDate != "" ? fromDate : null,
          toDate: toDate != "" ? toDate : null,
        },
      });
      const responseData = response.getAllReturns.data;

      let filteredData = [];
      if (tabValue === 0) {
        //filter pending status data
        filteredData = responseData.filter(
          (item) => item.status?.toLowerCase() === "pending"
        );
      } else if (tabValue === 1) {
        //filter the rest of the data
        filteredData = responseData.filter(
          (item) => item.status?.toLowerCase() !== "pending"
        );
      }

      setReturnsData(filteredData);
    } catch (error) {
      console.error("Error fetching Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Delete Function
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, DeleteReturnsManagement, {
            returnId: id,
          });

          const success = response?.deleteReturns?.success;
          const message = response?.deleteReturns?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
          fetchReturnsData();
        } catch (error) {
          console.error("Error Deleting Data: ", error);
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  //Status Change Function
  const handleChangeStatus = async (Id, val) => {
    const { value: formValues } = await Swal.fire({
      title: "Change Status",
      html: `
        <div style="text-align: left;">
          <label for="swal-status" style="font-weight: 600; display: block; margin-bottom: 6px;">
            Select Status
          </label>
          <div style="border: 1px solid #d0d0d0; border-radius: 6px; padding: 6px 10px; margin-bottom: 18px; background-color: #f9f9f9;">
            <select id="swal-status"
                    class="swal2-input"
                    style="width: 100%; border: none; background: transparent; outline: none;">
              <option value="">-- Select Status --</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          <div id="reason-container" style="display: none;">
            <label for="swal-reason" style="font-weight: 600; display: block; margin-bottom: 6px;">
              Reason for Rejection
            </label>
            <div style="border: 1px solid #d0d0d0; border-radius: 6px; padding: 6px 10px; background-color: #f9f9f9;">
              <textarea id="swal-reason"
                        class="swal2-textarea"
                        style="width: 80%; min-height: 80px; border: none; background: transparent; align-items: "center"; resize: vertical; outline: none;"></textarea>
            </div>
          </div>
        </div>

      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      preConfirm: () => {
        const status = document.getElementById("swal-status").value;
        const reason = document.getElementById("swal-reason").value;

        if (!status) {
          Swal.showValidationMessage("Please select a status.");
          return;
        }

        if (status === "Rejected" && !reason.trim()) {
          Swal.showValidationMessage("Reason is required for rejection.");
          return;
        }

        return { status, reason: reason.trim() };
      },
      didOpen: () => {
        const statusSelect = document.getElementById("swal-status");
        const reasonContainer = document.getElementById("reason-container");

        statusSelect.addEventListener("change", function () {
          reasonContainer.style.display =
            this.value === "Rejected" ? "block" : "none";
        });
      },
    });

    if (formValues) {
      const { status, reason } = formValues;

      try {
        setCirleLoading(true);
        const response = await request(BASEURL, statusChangeMutation, {
          input: {
            returnId: Id,
            status: status,
            rejectedReason: reason,
          },
        });
        const responseMessage = response?.approveOrRejectReturns?.message;
        const successStatus = response?.approveOrRejectReturns?.success;
        if (successStatus) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: responseMessage,
            showConfirmButton: true,
          });
          fetchReturnsData();
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: responseMessage,
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.error("Error Submitting Data: ", error);
      } finally {
        setCirleLoading(false);
      }
    }
  };

  //Date Filter
  // const filteredReturns = returnsData.filter((item) => {
  //   if (!fromDate || !toDate) return true;

  //   const created = new Date(item.createdAt);
  //   const from = new Date(fromDate);
  //   const to = new Date(toDate);

  //   return created >= from && created <= to;
  // });

  //Table Mapping
  const returnsTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 0.5,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "SO ID",
        field: "salesOrder",
        flex: 0.8,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer Name",
        field: "customer",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Status",
        field: "statusd",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Pick Up Status",
        field: "pickUp",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created On",
        field: "createdOn",
        flex: 1.2,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Created By",
        field: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Updated Status",
        field: "updatedAt",
        flex: 1.2,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Action",
        field: "action",
        flex: 0.8,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: returnsData.map((v, i) => ({
      id: v.id,
      sno: i + 1,
      salesOrder: v.salesOrder || "N/A",
      status: v.status || "N/A",
      customer: v.customerName || "N/A",
      statusd: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          {v?.status?.toLowerCase() === "rejected" && v?.rejectedReason ? (
            <Tooltip title={v.rejectedReason} disableInteractive>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#F44336",
                  cursor: "pointer",
                }}
              >
                {v.status}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                color:
                  v?.status?.toLowerCase() === "pending"
                    ? "#FFC107"
                    : v?.status?.toLowerCase() === "delivered"
                    ? "#2196F3"
                    : v?.status?.toLowerCase() === "approved"
                    ? "#4CAF50"
                    : v?.status?.toLowerCase() === "rejected"
                    ? "#F44336"
                    : "",
              }}
            >
              {v.status}
            </Typography>
          )}

          {v?.status?.toLowerCase() === "pending" && tabValue !== 4 && (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleChangeStatus(v?.id, v?.status)}
            />
          )}
        </Box>
      ),
      pickUp: v?.returnpickupstatus?.status ? (
        <PickedStatusChip
          status={v?.returnpickupstatus?.status}
          remarks={v?.returnpickupstatus?.remarks}
        />
      ) : (
        "N/A"
      ),
      createdOn: v.createdAt.slice(0, 10) || "N/A",
      createdBy: v.user.employeeName || "N/A",
      updatedAt: new Date(v?.updatedAt).toLocaleString() || "N/A",
      action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Returns Management Screen"
            component="ViewReturns"
          >
            <Tooltip disableInteractive title="View">
              <VisibilityIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate("/returns-management/return-Form", {
                    state: { type: "view", rowId: v?.id },
                  })
                }
              />
            </Tooltip>
          </RoleAccess>
          <RoleAccess
            modelName="Returns Management Screen"
            component="UpdateReturns"
          >
            {v.status === "Approved" && v.agentAssigned === false && (
              <Tooltip title="Delivery" disableInteractive>
                <DeliveryDining
                  fontSize="small"
                  className="actionIcon"
                  onClick={() => {
                    setFormState({ rowId: v.id, returnsData: v });
                    setDialogOpen(true);
                  }}
                />
              </Tooltip>
            )}
          </RoleAccess>
          <RoleAccess
            modelName="Returns Management Screen"
            component="DeleteReturns"
          >
            {tabValue === 0 && (
              <Tooltip title="Delete" disableInteractive>
                <DeleteIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() => handleDelete(v?.id)}
                />
              </Tooltip>
            )}
          </RoleAccess>
        </div>
      ),
    })),
  };

  //Tab Value Switch handleChange
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  //Download as Excel
  const exportToCSV = () => {
    const keysToExclude = ["id", "action", "user"];

    // Filter keys (headers)
    const headers = Object.keys(returnsData[0]).filter(
      (key) => !keysToExclude.includes(key)
    );

    const csvHeader = headers.join(",") + "\n";

    // Build rows with only allowed keys
    const csvRows = returnsData
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Returns_List.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show alert after a brief delay
    setTimeout(() => {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Returns Excel Downloaded Successfully",
        showConfirmButton: true,
      });
    }, 500); // slight delay to allow download to trigger
  };

  return (
    <DashboardLayout>
      <AssignDeliveryForm
        open={dialogOpen}
        setOpen={setDialogOpen}
        returnsData={formState}
        fetchReturnsData={fetchReturnsData}
      />
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Returns List
                  </MaterialTypography>
                </Stack>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  {returnsData.length > 0 && (
                    <button
                      className="container-btn-file"
                      onClick={exportToCSV}
                      style={{
                        height: "38px",
                        marginLeft: "0",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "14px",
                        marginRight: "20px",
                      }}
                    >
                      <svg
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                      </svg>
                      Export File
                    </button>
                  )}
                  <RoleAccess
                    modelName="Returns Management Screen"
                    component="CreateReturns"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() =>
                        navigate("/returns-management/return-Form", {
                          state: { type: "add" },
                        })
                      }
                    >
                      Returns
                    </MaterialButton>
                  </RoleAccess>
                </Box>
              </Stack>
              <Grid
                container
                spacing={2}
                sx={{ width: "100%", placeItems: "center" }}
              >
                <Grid size={{ lg: 5, xs: 12, sm: 3 }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#2a9941",
                        color: "white",
                      },
                    }}
                    centered
                  >
                    <Tab label="Pending" />
                    <Tab label="Completed" />
                  </Tabs>
                </Grid>
                <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      From Date <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    type="date"
                    name="formDate"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </Grid>
                <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      To Date <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    type="date"
                    name="endDate"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </Grid>
                <Grid size={{ lg: 1, xs: 6, sm: 2 }}>
                  <IconButton
                    onClick={() => {
                      setFromDate("");
                      setToDate("");
                    }}
                    aria-label="Reset Filters"
                    color="primary"
                    sx={{ mt: 2 }}
                  >
                    <RefreshIcon fontSize="large" />
                  </IconButton>
                </Grid>
              </Grid>
            </>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={returnsTable.rows}
            columns={returnsTable.columns}
          />
        )}
      </Card>
    </DashboardLayout>
  );
};

export default ReturnsManagement;
